import React from "react";
import { useTranslation } from "react-i18next";
import Header2 from "../../admin_components/Header/Header2";
import NewsAddComponent from "./component/NewsAddComponent";
const Write = () => {
  const { t } = useTranslation();
  return (
    <Header2
      title={[
        { title: t('Admin_News_title', '새소식'), url: "/admin/main/news" },
        {
          title: t('Admin_News_register', '새소식 등록'),
          url: 0,
        },
      ]}
    >
      <div className="w-full h-full ">
        <div className="px-[20px] py-[70px]">
          <NewsAddComponent />
        </div>
      </div>
    </Header2>
  );
};

export default Write;
